import React, { useState } from "react";
import {
  AddFlex,
  CustomInputArea,
  CustomInputLabel,
  PrimaryActionButton,
} from "./reusableStyles";
import { BoxedTabs } from "./BoxedTabs";
import FileUpload from "./FileUpload";
import { enqueueSnackbar } from "notistack";
import { handleImageUpload, isNullOrUndefined } from "../utils/utils";
import customClientAxios from "../customAxios";
import { EngageClients } from "../utils/ApiEndpoints";
import { CircularProgress } from "@mui/material";

function BroadcastDrawerComponent({ numbers }) {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [message, setMessage] = useState("");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSendMessage = async () => {
    try {
      let fileUrl;
      setLoading(true);
      if (message.length === 0) {
        return enqueueSnackbar("Enter Message", {
          variant: "error",
        });
      }
      if (
        (selectedTabIndex === 1 || selectedTabIndex === 2) &&
        isNullOrUndefined(file)
      ) {
        return enqueueSnackbar("Upload file", {
          variant: "error",
        });
      }
      if (file) {
        fileUrl = await handleImageUpload(file, "superAdmin");
      }
      const response = await customClientAxios().post(EngageClients, {
        message,
        fileUrl,
        fileName: file?.name,
        numbers,
        index: selectedTabIndex,
      });
      enqueueSnackbar("Message Sent!", {
        variant: "success",
      });
    } catch (error) {
      console.log(error);
      enqueueSnackbar("Failed!", {
        variant: "error",
      });
    }
  };
  const getComponent = () => {
    switch (selectedTabIndex) {
      case 0:
        return (
          <AddFlex flexDirection="column">
            <CustomInputLabel>Enter message</CustomInputLabel>
            <CustomInputArea
              onChange={(e) => {
                setMessage(e.target.value);
              }}
              style={{ height: "40vh", fontSize: "12px" }}
            />
          </AddFlex>
        );
      case 1:
        return (
          <AddFlex gap="20px" flexDirection="column">
            <div>
              <CustomInputLabel>Enter message</CustomInputLabel>
              <CustomInputArea
                onChange={(e) => {
                  setMessage(e.target.value);
                }}
                style={{ height: "40vh", fontSize: "12px" }}
              />
            </div>
            <FileUpload
              handleGetFileData={(file) => {
                setFile(file);
              }}
            />
          </AddFlex>
        );
      case 2:
        return (
          <AddFlex gap="20px" flexDirection="column">
            <CustomInputLabel>Enter message</CustomInputLabel>
            <CustomInputArea
              onChange={(e) => {
                setMessage(e.target.value);
              }}
              style={{ height: "40vh", fontSize: "12px" }}
            />
            <FileUpload
              handleGetFileData={(file) => {
                setFile(file);
              }}
            />
          </AddFlex>
        );
    }
  };
  return (
    <AddFlex padding="30px" gap="20px" flexDirection="column">
      <BoxedTabs
        selectedTabIndex={selectedTabIndex}
        setSelectedTabIndex={setSelectedTabIndex}
        tabs={[
          { name: "Text" },
          { name: "Text and Media" },
          {
            name: "Text and Document",
          },
        ]}
      />
      {getComponent()}
      <PrimaryActionButton
        style={{ height: "44px" }}
        onClick={handleSendMessage}
      >
        {loading ? (
          <CircularProgress size={14} sx={{ color: "white" }} />
        ) : (
          `Send Message to ${numbers?.length} clients`
        )}
      </PrimaryActionButton>
    </AddFlex>
  );
}

export default BroadcastDrawerComponent;
